export default {
  recommendations: state => state.recommendations,
  recommendation: state => state.recommendation,
  step: state => state.step,
  visitedStep: state => state.visitedStep,
  translations: state => state.translations,
  testdriveResultType: state => state.testdriveResultType,
  testdriveResultTypes: state => state.testdriveResultTypes,
  exclusions: state => state.exclusions,
  adasmatrix: state => state.adasmatrix,
  adasmatrices: state => state.adasmatrices,
  decodedVin: state => state.decodedVin,
  decodedAltVin: state => state.decodedAltVin,
  adasmakematrices: state => state.adasmakematrices,
  adasmakematrix: state => state.adasmakematrix,
  adasmatrixinfolookups: state => state.adasmatrixinfolookups,
  adasmatrixinfolookup: state => state.adasmatrixinfolookup,
  adasLink: state => state.adasLink,
  adasLinks: state => state.adasLinks,
  adasMakeMatrixCategories: state => state.adasMakeMatrixCategories,
  adasMakeMatrixSubCategories: state => state.adasMakeMatrixSubCategories,
  makeExceptions: state => state.makeExceptions,
  matrixKeywordsTriggers: state => state.matrixKeywordsTriggers,
  matrixAdasInfo: state => state.matrixAdasInfo,
  makeExceptionLookups: state => state.makeExceptionLookups,
  noScrubList: state => state.noScrubList,
  noScrubItem: state => state.noScrubItem,
  systemCalibrations: state => state.systemCalibrations,
  calibrationPricing: state => state.calibrationPricing,
  blueprintInfoLookups: state => state.blueprintInfoLookups,
  blueprintInfoLookup: state => state.blueprintInfoLookup,
  decodeScrubRules: state => state.decodeScrubRules,
  decodeScrubRule: state => state.decodeScrubRule,
  eulas: state => state.eulas
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/getters.js